<template>
  <div id="page-history">
    <h5 class="m-4 page-header"> >> {{ $t('AUTH.MENU.HISTORY') }}</h5>

    <memlist-card class="px-0">

      <div class="ml-tabs">
        <div class="ml-tabs-header">
          <button
            type="button"
            v-for="(tab, i) in tabs"
            :key="i"
            :class="['ml-tab-button', active_tab === i ? 'active' : '']"
            @click="active_tab = i"
            :disabled="tab.disabled"
          >
            {{ $t(tab.label) }}
          </button>
        </div>

        <div class="ml-tabs-body">
          <div v-show="active_tab === 0">

            <HistoryEditor
              class="mt-4"
              ref="history_editor"
              group="USER"
              v-if="selected_history"
              :history="selected_history"
            />

            <HistoryTable 
              class="mt-4"
              group="USER"
              ref="user-history-table"
            />
          </div>
          <div v-show="active_tab === 1">

            <HistoryEditor
              class="mt-4"
              ref="history_editor"
              group="MEMBER"
              v-if="selected_history"
              :history="selected_history"
            />

            <HistoryTable 
              class="mt-4"
              group="MEMBER"
              ref="member-history-table"
            />

          </div>
          <div v-show="active_tab === 2">
            <HistorySettings />
          </div>
        </div>
      </div>

    </memlist-card>
  </div>
</template>

<script>

// axios is REST API
import axios from 'axios';

// popup messages in the corner
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

// vuex state, storage
import { mapGetters } from 'vuex';

// Edit component
import HistoryTable from './history/HistoryTable.vue';
import HistoryEditor from './history/HistoryEditor.vue';
import HistorySettings from './history/HistorySettings.vue';

export default {
  name: 'history-page',
  mixins: [ toasts ],
  components: {
    HistoryTable,
    HistoryEditor,
    HistorySettings
},
  computed: {
    tabs() {

      let base = [
        { label: 'HISTORY.USERS', disabled: false },
        { label: 'HISTORY.MEMBERS', disabled: false },
        { label: 'HISTORY.SETTINGS', disabled: false },

      ];
      
      return base;
    },
    // which stored data we want to use
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'settings'])
  },
  mounted() {
    //this.example = this.examples[0];
  },
  data() {
    return {
      active_tab: 0,
      selected_history: null
    };
  },
  watch: {
    active_tab() {
      if (this.active_tab === 0) {
        this.$refs['user-history-table'].refresh();
      }
      else if (this.active_tab === 1) {
        this.$refs['member-history-table'].refresh();
      }
    },
    currentCompanyId() {
      // triggers when user has changed company on top
      // we should reload content based on selected company
    },
    currentPeriodId() {
      // triggers when user has changed period on top
      // we should reload content based on period
    }

  },
  methods: {

  }
};
</script>
